import { defineNuxtPlugin } from '#imports'
import { useVehiclesStore } from '~/stores/vehicles'
// import { nextTick } from 'vue' // No longer needed
import { useSiteStore } from '~/stores/site'
import { usePromotionalStore } from '~/stores/promotional'
// import { devLog } from '~/utils/logger' // Ensure this remains removed or path is correct
import type { NuxtApp } from '#imports' // Reinstate NuxtApp type

// Plugin runs automatically after app creation/hydration on client-side
export default defineNuxtPlugin(async (nuxtApp) => { // Type inferred by defineNuxtPlugin
  // We only want this to run on client
  if (!process.client) return

  // Use type assertion for hooks property if NuxtApp type is incomplete
  (nuxtApp as any).hooks.hook('app:mounted', async () => {
    // Code here runs after app is hydrated and ready on client
    try {
      // Add defensive checks to ensure Pinia is ready
      const pinia = nuxtApp.$pinia
      if (!pinia) {
        console.warn('[ClientFix] Pinia not available, skipping store initialization')
        return
      }

      const siteStore = useSiteStore()
      const promotionalStore = usePromotionalStore()
      const vehiclesStore = useVehiclesStore()
      
      // Ensure site store is initialized
      if (!siteStore.isInitialized) {
        siteStore.initialize();
      }
      
      // Initialize promotional content if available
      if (siteStore.promotional && Array.isArray(siteStore.promotional) && 
          siteStore.promotional.length > 0 && siteStore.promotional[0] && siteStore.promotional[0].slides) {
        promotionalStore.initializeFromData(siteStore.promotional)
      }
      
      // Check vehicles store state after hydration
      if (vehiclesStore.isDataLoaded && vehiclesStore.vehicles.length > 0) {
        
        // Initialize available filters if data is loaded
        // Call initializeAvailableFilters directly - it has internal checks
        vehiclesStore.initializeAvailableFilters(); 
          
      } else if (!vehiclesStore.isDataLoaded && vehiclesStore.vehicles.length > 0) {
        console.log('[ClientFix] Fixing vehicles store state - data exists but flag not set');
        vehiclesStore.isDataLoaded = true; // Correct the flag
        
        // Initialize available filters
         console.log('[ClientFix] Initializing available filters after fixing state flag');
        vehiclesStore.initializeAvailableFilters(); 
      }
      
      // devLog('[ClientFix] Client-side initialization complete')
    } catch (err) {
      console.error('[ClientFix] Error in client hydration fix:', err)
    }
  })
}); 